
export default {
  computed: {
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    projectsList () {
      return this.$store.getters.projectsList
    }
  },
  methods: {
    updateRow (row, data) {
      const { totalTime: newTotalTime, endDate } = data
      const { commentStartDate, totalTime } = row
      row.totalTime = totalTime + newTotalTime
      row.commentStartDate = commentStartDate || endDate
      row.dateLastUpdate = endDate
      row.lastStep = data
    },
    updateProject ({row, data, isSubproject, isHourProject}) {
      if (isSubproject) {
        const { project } = this.activeTimer
        const parentProject = this.projectsList.find((c) => c._id === project)
        if (parentProject) this.updateRow(parentProject, data)
        this.updateRow(row, data)
      } else if (isHourProject) {
        const { subprojectId } = this.activeTimer
        const subProject = this.projectsList.find((c) => c._id === subprojectId)
        if (subProject) this.updateRow(subProject, data)
        this.updateRow(row, data)
      } else {
        this.updateRow(row, data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/updateProject.js